// extracted by mini-css-extract-plugin
module.exports = {"AppLogoContainer":"Loading_AppLogoContainer__3hFEA","AppLogo":"Loading_AppLogo__l7JsP"};